let DP_ID = Date.now();

export function generateId() {
  DP_ID += 1;
  return `dp-${(DP_ID).toString(36).toLowerCase()}`;
}

export function transformSchema(schema) {
  if (Array.isArray(schema)) {
    return {
      offline: schema,
      online: [],
      sync: true,
      globalConfig: {},
    };
  }
  return schema;
}

export function classifyItems(items) {
  const asyncLoad = [];
  const manualLoad = [];
  const autoLoad = [];
  (items || []).forEach((item) => {
    let config = item.getConfig();
    if (item.type === 'REMOTE') {
      const ctx = item.otherOptions[0];
      if (ctx && config.sharedConfig) {
        const sharedConfig = config.sharedConfig[ctx.getCurrentPageId()];
        if (sharedConfig) {
          config = { ...config, ...sharedConfig };
        }
      }
      if (config.loadType === 'MANUAL') {
        manualLoad.push(item);
      } else if (config.loadType === 'ASYNC') {
        asyncLoad.push(item);
      } else {
        autoLoad.push(item);
      }
    } else {
      autoLoad.push(item);
    }
  });
  return {
    asyncLoad,
    manualLoad,
    autoLoad,
  };
}
